import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { IMainComponentProps } from "./IMainComponentProps";
import MainLoading from "../../components/mainLoading";
import { Map } from "immutable";
import {
  authorizeActions,
  globalActions,
  groupActions
} from "../../store/actions";
import { push } from "connected-react-router";
import TopBarComponent from "../../components/topBar";
import "./MainComponent.scss";
import "./main-responsive.scss";
import { AuthorizeService } from "../../api/services/authorize";
import UserSettingsContainer from "containers/UserSettingsContainer";
import SearchContainer from "containers/SearchContainer";
import UserAccesContainer from "containers/UserAccesContainer/UserAccesContainer";
import NotificationsContainer from "containers/NotificationsContainer";
import GroupContainer from "containers/GroupContainer";
import CreateGroupContainer from "containers/CreateGroupContainer";
import appConfig from "appConfig";
import jsonwebtoken from "jsonwebtoken";
import NotFound from "../notFound";
import { GroupService } from "../../api/services/groups";
import store from "../../store/configureStore";
import miscUtils from "utils/miscUtils";
import Favicon from "react-favicon";
import TagManager from "react-gtm-module";
import { removeCookieValue, setCookieValue } from "../../utils/cookieStorage";
import { CommonConstants } from "../../constants/common";
import VerifyAccountComponent from "containers/selfSignup/VerifyAccountComponent";
import { toast } from "react-toastify";
import { defaultFaviconUrl } from "./domain";
import { chatsAtom, chatsIsUpdatedAtom, chatsLoadingAtom, communityBillingPlansPopupAtom, groupDataLoadingAtom, NewCommunityPopupAtom, showBannerAtom, showMessagePopUpAtom, showUpgradeBannerAtom } from "showMessageMenuAtom";
import { atom, useAtom } from "jotai";
import MessagingContainer from "containers/messaging";
import { MessagingService } from "api/services/messaging";
import EmailWhitelabelingSuccess from "components/EmailWhitelabelingSuccess";
import Home from "containers/home";
import Facebook from "Facebook";
import * as Sentry from "@sentry/react";
import AccessRestricted from "containers/AccessRestricted";
import NotFoundComponentAlt from "containers/notFound/NotFoundComponentAlt";
import PreviewBanner from "components/PreviewBanner/PreviewBanner";

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import AdminOnboardingChecklist from "containers/groupView/AdminOnboardingChecklist";
import { BillingCycles, PlanNames } from "containers/groupAppPricing/domain";
import { useLocation } from "react-router";
import AdminCommunities from "components/AdminCommunities/AdminCommunities";
import AppLoadingSpinner from "components/AppLoadingSpinner";

import NewCommunityPopup from "components/NewCommunityPopup/NewCommunityPopup";
import NotFoundComponent from "containers/notFound/NotFoundComponent";

dayjs.extend(utc);
dayjs.extend(timezone);

export const AppContext = React.createContext<any>(null);
export const DirectChatsContext = React.createContext<any>({});
// open invite members page
export const openInviteMembersPageAtom = atom(false);

const MainComponent: React.FC<IMainComponentProps> = props => {

  const toggleLectureMenuRef = useRef();
  const refreshNotificationsCountRef = useRef();
  const isSidebarEmptyRef = useRef(false);
  const resetGroupDataRef = useRef();

  const [subdomain, setCurrentSubdomain] = useState<any>();
  const [onboardingChecklistActive, setOnboardingChecklistActive] = useState<string>("");
  const [user, setUser] = useState<any>(null);
  const [group, setGroup] = useState<any>(null);
  const [groupChannels, setGroupChannels] = useState<any>(null);
  const [openNewCommunityPopup, ] = useAtom(NewCommunityPopupAtom);   
  const [isLoadingGroup, setIsLoadingGroup] = useState<boolean>(true);
  const [isCustomDomain, setIsCustomDomain] = useState<boolean>(false);
  const {
    global,
    isAuthed,
    logout,
    login,
    getUserGroups,
    hideTopLoading
  } = props;
  let baseResponsiveClass = "";
  const [onTrial, setOnTrial] = useState<boolean>();
  const [communityFavicon, setCommunityFavicon] = useState<string>("");
  const [checkingRedirect, setCheckingRedirect] = useState<boolean>(true);
  const [showFavicon, setShowFavicon] = useState<boolean>(false);
  const [isInvitePreview, setIsInvitePreview] = useState<boolean>(false);
  const [isInvited, setIsInvited] = useState<boolean>(false);
  const [isTeamMember, setIsTeamMember] = useState<boolean>(false);
  const [queryString, setQueryString] = useState<string>('');
  const [showDefaultLandingPage, setShowDefaultLandingPage] = useState<boolean>(false);
  const [groupMembershipData, setGroupMembershipData] = useState<any>(null);
  const tmp_user = store.store.getState().getIn(["authorize", "user"]);
  const [loggedinUser, setLoggedinUser] = useState<any>(tmp_user)
  const [isGroupEligibleForTrial, setIsGroupEligibleForTrial] = useState<boolean>(false);

  useEffect(() => {
   if (!loggedinUser)setLoggedinUser(tmp_user)
   }, [JSON.stringify(tmp_user)])

  const search = props.location.search;
  const params = new URLSearchParams(search);
  const membersRef = React.useRef(null);

  const [openMessagePopUp,] = useAtom(showMessagePopUpAtom);
  const [, setCommunityChats] = useAtom(chatsAtom) as any;
  const [, setIsLoading] = useAtom(chatsLoadingAtom);
  const [chatIdUpdated,] = useAtom(chatsIsUpdatedAtom);

  const FBpixelId = group && group.ex_config && group.ex_config.facebook_pixel
  const MetapixelId = group && group.ex_config && group.ex_config.meta_pixel

  const refreshGroupPostsWithoutLoadRef = React.useRef<any>(null);

  const pixelId = FBpixelId || MetapixelId;

  function getIndividualChatMembers(chat: any) {
    try {
      const encounteredIds = new Set();
      const individualChat = chat.members.filter((member: any) => {
        if (
          member.community_member &&
          (member.community_member.user !== null && member.community_member.user !== undefined)
        ) {
          const memberId = member.community_member.id;
          if (!encounteredIds.has(memberId)) {
            encounteredIds.add(memberId);
            return true;
          }
        }
      });

      return individualChat;
    } catch (error) {
      // Handle the error
      console.error(error);
    }
  }

  const [memberCommunityUnreadCount, setMemberCommunityUnreadCount] = useState<number>(0);
  const [directChats, setdirectChat] = useState<any>([]);

  const getDirectChats = async (limit?: number) => {
    try {
      if (chatIdUpdated) {
        return
      } else {
        const chatrooms: any = await MessagingService.getInstance().getUserChatrooms(group && group.id, "", 1, "");
        const sortedChats = chatrooms && chatrooms.data.filter((chat: any) => {
          if (chat.type === "group") {
            return chat.members.length >= 2;
          } else if (chat.type === "individual") {
            const individualChat = getIndividualChatMembers(chat);
            if (individualChat && individualChat.length > 1) {
              return true;
            }
          }
        })

        setCommunityChats(
          {
            data: sortedChats,
            chatrooms
          },
        )
        setIsLoading(false);
        const filteredMinusGroup = sortedChats.length > 0 && sortedChats.filter((chat: any) => chat.type === 'individual')
        setdirectChat(filteredMinusGroup)
      }
    } catch (error) {
      console.error(error)
    }
  };

  const loadMoreChats = async () => {
    try {
      const chatrooms: any = await MessagingService.getInstance().loadMoreChatrooms(directChats && directChats.chatrooms.next_page_url);
      const sortedChats = chatrooms && chatrooms.data.filter((chat: any) => {
        if (chat.type === "group") {
          return chat.members.length >= 2;
        } else if (chat.type === "individual") {
          const individualChat = getIndividualChatMembers(chat);
          if (individualChat && individualChat.length > 1) {
            return true;
          }
        }
      })
      setCommunityChats(
        {
          data: [...directChats.data, ...sortedChats],
          chatrooms
        },
      )
    } catch (error) {
      console.error(error)
    }
  };

  const [chatHistory, setChatHistory] = useState<any>(null)
  const [isMemberAddGroupChat, setIsMemberAddGroupChat] = useState<boolean>(false)
  const groupCount = group && group.user_membership && group.user_membership.unread_messages_count;


  const getCommunityUnread = () => {
    // const groupSlug = props.location.pathname.split("/")[2];
    if (chatIdUpdated) {
      return
    } else {
      // GroupService.getInstance()
      //   .getGroup(subdomain || params || groupSlug)
      //   .then((groupData: any) => {
      //     const groupCount = groupData.user_membership && groupData.user_membership.unread_messages_count;

      //     if (groupCount > 0) {
      //       setMemberCommunityUnreadCount(parseInt(groupCount));
      //     }
      //     else {
      //       setMemberCommunityUnreadCount(0);
      //     }
      //   }).catch((error: any) => console.error(error))
      if (groupCount > 0) {
            setMemberCommunityUnreadCount(parseInt(groupCount));
          }
          else {
            setMemberCommunityUnreadCount(0);
          }
    }
  }

  useEffect(() => {
    if (group && miscUtils.isGroupMember(group && group)) {
      getDirectChats()
      getCommunityUnread()
    }
  }, [group && group.id, chatIdUpdated])

  const [isLoadingMessages, setIsLoadingMessages] = useState<boolean>(true);
  const [chatroom, setChatroom] = useState<any>({});
  const [isCreateDirectchat, setIsCreateDirectchat] = useState<boolean>(false);
  const [chatIsclicked, setChatIsclicked] = useState<boolean>(false)
  const [, setGroupDataisLoading] = useAtom(groupDataLoadingAtom);
  const [userBlockedError, setUserBlockedError] = useState<string>('');
  const [groupDataError, setGroupDataError] = useState<any>(null);

  useEffect(() => {
    if ((window.location.pathname.split("/")[1] === "settings") && group && group.user_membership) {
      return
    }
    if ((window.location.pathname.split("/")[1] === "courses") && group && group.user_membership) {
      return
    }
    if ((window.location.pathname.split("/")[1] === "library") && group && group.user_membership) {
      return
    }
     if ((window.location.pathname.split("/")[1] === "feed") && group && group.user_membership) {
      return
    }
    if ((window.location.pathname.split("/")[1] === "events") && group && group.user_membership) {
      return
    }
    if ((window.location.pathname.split("/")[1] === "members") && group && group.user_membership) {
      return
    }
    if ((window.location.pathname.split("/")[1] === "channel") && group && group.user_membership) {
      return
    }
    if ((window.location.pathname.split("/")[1] === "home") && group && group.user_membership) {
      return
    }
    if (window.location.hostname.includes("group.app") || window.location.hostname.includes("group.localhost")) {
      const [currentSubdomain] = window.location.hostname.split(".");

      if (currentSubdomain && !appConfig.reservedSubdomains.includes(currentSubdomain)) {
        setCurrentSubdomain(currentSubdomain);
        setGroupDataisLoading(true)
        GroupService.getInstance()
          .getGroup(currentSubdomain)
          .then((groupData: any) => {
            setIsLoadingGroup(false);
            // setGroupDataisLoading(false)
            setGroup(groupData);
            determineLoginRedirect(groupData);
            if (
              groupData &&
              groupData.custom_domain_status === "active" &&
              appConfig.env !== "dev"
            ) {
              // const redirectUrl = `http://${groupData.custom_domain}${window.location.pathname}`;
              // window.location.assign(redirectUrl);
              const url = new URL(window.location.href)
              const redirectUrl = `http://${groupData.custom_domain}${window.location.pathname}`;

              // fix the issue of query params disappering
              const pathandQuery = redirectUrl + url.search;
              window.location.assign(pathandQuery);
            }
          })
          .catch((error: any) => {
            setIsLoadingGroup(false)
            setGroupDataisLoading(false)
            setUserBlockedError(error && error.data && error.data.message)
            setGroupDataError(error)
          })
          .finally(() => setGroupDataisLoading(false))
      } else {
        setCurrentSubdomain(null);
      }
    } else {
      setIsCustomDomain(true);
      GroupService.getInstance()
        .getGroup(window.location.hostname)
        .then((groupData: any) => {
          if (groupData) {
            determineLoginRedirect(groupData);
            setIsLoadingGroup(false);
            setGroup(groupData);
            setCurrentSubdomain(groupData.subdomain);
          } else {
            setCurrentSubdomain(null);
          }
        })
         .catch((error: any) => {
            setIsLoadingGroup(false)
            setGroupDataisLoading(false)
            setUserBlockedError(error && error.data && error.data.message)
            setGroupDataError(error)
          })
          .finally(() => setGroupDataisLoading(false))
    }

    if (
      !window.location.pathname.includes("channel") &&
      props.location.pathname !== "/"
    ) {
      setOnboardingChecklistActive("");
    }

    if (window.location.pathname === "/invite-preview") {
      setIsInvitePreview(true);
    } else {
      setIsInvitePreview(false);
    }

    if (window.location.pathname === "/invite" && (!isTeamMember)) {
      setIsInvited(true);
    } else {
      setIsInvited(false);
    }
    setQueryString(params.toString());

    const { pathname } = window.location;
    if (group) {
      if (((pathname === "/courses" || pathname === "/courses/") && !group.menu['courses']['show'])
        || ((pathname === "/library" || pathname === "/library/") && !group.menu['library']['show'])
        || ((pathname === "/events" || pathname === "/events/") && !group.menu['events']['show'])
        // || ((pathname === "/messages" || pathname === "/messages/") && !group.menu['messages']['show'])
        || (pathname === "/members" && !group.menu['people']['show'])
        || (pathname === "/about" && !group.menu['profile']['show'])
        || (pathname === "/feed" && !group.menu['feed']['show'])
      ) {
        if (group.home_page_config.status) {
          window.location.assign('/');
        } else {
          window.location.assign(`/channel/${group.default_channel.slug}`);
        }
      }
    }

  }, [props.location.pathname, isTeamMember]);

  useEffect(() => {
    if (group) {
      if (group && group.google_tag_id) {
        TagManager.initialize({ gtmId: group.google_tag_id });
      }

      setCommunityFavicon(getCommunityFavicon());
      setShowFavicon(true);
      document.title = group.name;
      const theme = {
        custom: group.custom_branding ? group.custom_branding : null
      };
      store.store.dispatch(globalActions.setGroupTheme(theme));
      store.store.dispatch(globalActions.setSelectedGroup(group));
      getTrialStatus();

      if (group && group.user_membership) {
        setIsTeamMember(true);
      } else {
        setIsTeamMember(false);
      }
      if (window.location.pathname === "/onboarding") {
        if (group.onboarding_completed || !(miscUtils.isTeamMember(group && group.user_membership))) {
          props.history.push("/");
        }
      }

      if (
        window.location.pathname === "/upgrade" &&
        (
          !miscUtils.isTeamMember(group && group.user_membership) ||
          !miscUtils.isGroupOnFreePlan(group)
        )
      ) {
        props.history.push("/");
      }
    }
  }, [group]);

  useEffect(() => {
    AuthorizeService.getInstance().onAuthStateChanged(handleAuthStateChanges);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthed]);
  const [, setShowBanner] = useAtom(showBannerAtom);

  const [, setShowUpgradeBanner] = useAtom(showUpgradeBannerAtom) as any;

  useEffect(() => {
    if (
      !(//user is on upgrade screen
        window.location.pathname.split("/").length === 2 &&
        window.location.pathname.split("/").pop() === "upgrade"
      ) &&
      !(//user is on onboarding screen
        window.location.pathname.split("/").length === 2 &&
        window.location.pathname.split("/").pop() === "onboarding"
      ) &&
      !(//user is in landing page builder
        window.location.pathname.split("/")[2] === "landing-pages" &&
        window.location.pathname.split("/").pop() === "edit"
      ) &&
      !(//user is in workflows builder
        window.location.pathname.split("/")[2] === "workflows" &&
        window.location.pathname.split("/").pop() === "edit"
      ) &&
      !(//user is in certificates builder
        window.location.pathname.split("/")[2] === "certificates" &&
        window.location.pathname.split("/").pop() === "edit"
      ) &&
      window.location.pathname.split("/")[1] !== "pages-preview" &&
      window.location.pathname !== "group_billing_cancellation" &&
      window.location.pathname !== "email_unsubscription" &&
      window.location.pathname !== "/verify-email" &&
      isAuthed &&
      group
    ) {
      const userTimezone = dayjs.tz.guess();

      if (
        miscUtils.isGroupOnFreePlan(group) &&
        miscUtils.isAdmin(group.user_membership)
      ) {
        setShowUpgradeBanner({
          isOpen: true,
          isWithin7Days: miscUtils.isWithinPastXDays(group && group.created_at, 14),
          upgradeBeforeDate: miscUtils.getTrialInfo(group && group.active_subscription.trial_ends_at),
          isFreeCommunity: miscUtils.isGroupOnFreePlan(group),
          daysLeft: miscUtils.getDaysLeft(group && group.active_subscription.trial_ends_at),
          isOnTrail: group && group.active_subscription && group.active_subscription.on_trial
        });
      } else if (
        group.active_subscription &&
        group.active_subscription.on_trial &&
        miscUtils.isAdmin(group.user_membership)
         &&
        (
          (group.active_subscription.plan.interval === BillingCycles.MONTHLY) &&
          (group.active_subscription.plan.name !== PlanNames.BUSINESS)
        )
      ) {
        setShowUpgradeBanner({
          isOpen: true,
          daysLeft:  miscUtils.getDaysLeft(group && group.active_subscription.trial_ends_at),
          isWithin7Days: miscUtils.isWithinPastXDays(group && group.created_at, 7),
          upgradeBeforeDate: dayjs.utc(miscUtils.getExpirationDate(group && group.created_at, 7)).
            tz(userTimezone).format('MMM D, [at] hh:mm A'),
          trialDate: miscUtils.convertDateStringToUsertimezoneFormat(group.active_subscription.trial_ends_at),
          isFreeCommunity: miscUtils.isGroupOnFreePlan(group)
        });
      } 
      else if (
        group.active_subscription &&
        group.active_subscription.on_trial &&
        miscUtils.isAdmin(group.user_membership) &&
        (group.active_subscription.plan.name === PlanNames.BUSINESS)
      ) {
        setShowUpgradeBanner({
          isOpen: true,
          daysLeft: isADayLeftOnTrial() ? '1 day' : getTrialDate(),
          trialDate: miscUtils.convertDateStringToUsertimezoneFormat(group.active_subscription.trial_ends_at),
          isFreeCommunity: miscUtils.isGroupOnFreePlan(group)
        });
      } 
      else if (
        group.active_subscription &&
        group.active_subscription.on_trial &&
        miscUtils.isAdmin(group.user_membership) &&
        (group.active_subscription.plan.interval !== BillingCycles.MONTHLY) &&
        (group.active_subscription.plan.name !== PlanNames.BUSINESS)
      ) {
        setShowUpgradeBanner({
          isOpen: true,
          daysLeft: isADayLeftOnTrial() ? '1 day' : getTrialDate(),
          trialDate: miscUtils.convertDateStringToUsertimezoneFormat(group.active_subscription.trial_ends_at),
          isFreeCommunity: miscUtils.isGroupOnFreePlan(group)
        });
      } 
      else if (
        group.user_membership &&
        group.user_membership.user &&
        !group.user_membership.user.verified &&
        !miscUtils.isTeamMember(group && group.user_membership) &&
        isAuthed
      ) {
        setShowUpgradeBanner({
          isOpen: true,
          emailNotVerified: true,
          fn: resendCode,
        });
      } else if (
        group.user_membership &&
        miscUtils.isAdmin(group.user_membership) &&
        !onTrial &&
        group.active_subscription &&
        group.active_subscription.stripe_status === "past_due"
      ) {
        setShowUpgradeBanner({
          isOpen: true,
          cardChargedFailed: true,
        });
      } else {
        setShowUpgradeBanner({ isOpen: false });
      }
    } else {
      setShowUpgradeBanner({ isOpen: false });
    }


  }, [isAuthed, group, window.location.pathname]);


  const location = useLocation();
useEffect(() => {
  // Don't show banner if no group exists
  const isGroupAppSignupPath = location.pathname === "/signup";
  if ((!group && location.pathname !== "/login") || isGroupAppSignupPath || (group === null && location.pathname !== "/login")) {
    setShowBanner(false);
    return;
  };

  // Path-based conditions where banner should never show
  const isPurchasePath = location.pathname.split("/").pop() === "purchase";
  const ispaymentPath = isPurchasePath && new URLSearchParams(location.search).has("payment_option");

  const isCheckoutPath = ['/plan-subscription', '/plan-subscription/checkout'].includes(location.pathname);

  // User-based condition where banner should never show
  const isTeamMember = isAuthed && miscUtils.isTeamMember(group && group.user_membership);

  // Exit early if banner should never be shown for this user/path
  if (isTeamMember || isCheckoutPath || ispaymentPath || isPurchasePath || isGroupAppSignupPath) {
    setShowBanner(false);
    return;
  } else {
    // Check mobile device type
    const userAgent = navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/.test(userAgent) ||
      (/Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1);
    const isAndroid = /Android/.test(userAgent);
    const isMobileDevice = isIOS || isAndroid;

    // Only proceed with timing logic if on a mobile device
    if (isMobileDevice) {
      const isBannerTimingValid = miscUtils.shouldDownloadShowSmartBanner();


      if (isBannerTimingValid) {
        let lastScrollY = window.scrollY;
        let isScrollingDown = false;
        let bannerHiddenByScroll = false;

        const handleScroll = () => {
          const shouldStillShow = miscUtils.shouldDownloadShowSmartBanner();
          if (!shouldStillShow) {
            setShowBanner(false);
            return;
          }

          const currentScrollY = window.scrollY;
          if (currentScrollY <= 0) {
            // At the very top, ignore upward scrolls
            lastScrollY = currentScrollY;
            return;
          }

          const scrollDifference = currentScrollY - lastScrollY;

          if (Math.abs(scrollDifference) < 5) {
            lastScrollY = currentScrollY;
            return;
          }

          const isAtBottom = (window.innerHeight + currentScrollY) >= (document.documentElement.scrollHeight - 10);

          if (scrollDifference > 0) {
            // Scrolling down
            if (!isScrollingDown) {
              isScrollingDown = true;
              bannerHiddenByScroll = true;
              setShowBanner(false);
            }
          } else if (scrollDifference < 0 && !isAtBottom) {
            // Scrolling up, but not if we’re at bottom
            if (isScrollingDown && bannerHiddenByScroll) {
              isScrollingDown = false;
              setShowBanner(true);
            }
          }

          lastScrollY = currentScrollY;
        };


        // Add scroll event listener
        window.addEventListener('scroll', handleScroll, { passive: true });

        // Initially show banner
        setShowBanner(true);

        // Cleanup function to remove event listener
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      } else {
        setShowBanner(false);
      }
    } else {
      setShowBanner(false);
    }
  }
}, [isAuthed, group, location]);

  function handleAuthStateChanges(user: any) {
    hideTopLoading!();
    const query = new URLSearchParams(props.location.search);
    const t = query.get("t");
    const q = query.get("q");
    if (q && t) {
      const usr = jsonwebtoken.verify(q, 'dLS*@eP+YuGe!AzD&vUwH%Fch*$R-&mdu?9!4zRfmXrzcp8uQfjZazW3S_dE+Bw', { algorithms: ['HS256'] });
      // tslint:disable-next-line:no-parameter-reassignment
      setCookieValue(CommonConstants.USER_TOKEN, t);
      setCookieValue(CommonConstants.USER_KEY, usr);

      user = usr;
    }

    if (user) {
      setUser(user);
      if (typeof user.id !== "undefined") {
        // Identify the user
        Sentry.configureScope((scope: any) => {
          scope.setUser({ email: user.email });
        });
        (window as any).clarity("set", "USER_EMAIL", user.email);
        (window as any).clarity("set", "USER_NAME", user.full_name);
        (window as any).clarity("identify", user.email);
      }
      // getUserGroups(user.id);
      login(user);
    }
  }

  useEffect(() => {
    if (user) {
      getUserGroups(user.id);
    }
  }, [user && user.id]);

  function determineLoginRedirect(group: any) {
    let selectPlan = false;
    let freePlanId: any;

    if (group.plans) {
      group.plans.forEach(function (plan: any) {
        if (plan.price > 0 && !plan.archived_at && !plan.hidden) {
          selectPlan = true;
        }
        if (plan.price === 0) {
          freePlanId = plan.id;
        }
      });
      const freePlans = group.plans.filter((plan: any) => plan.price === 0 && !plan.archived_at);
      if (freePlans.length > 1) {
        selectPlan = true;
      }
    }

    if (group &&
      !miscUtils.isActiveCommunityMember(group.user_membership) &&
      !group.user_membership &&
      isAuthed &&
      window.location.pathname === "/") {
      const planUrl = params.get("utm_content");

      if (planUrl && window.location.pathname === "/") {
        props.history.push(`/plan-subscription${queryString.length > 0 ? `?${queryString}` : ""}`);
      }

      if (params.get("join") === "true" && selectPlan && window.location.pathname === "/") {
        if (subdomain) {
          props.history.push(`/plan-subscription${queryString.length > 0 ? `?${queryString}` : ""}`);
        } else {
          props.history.push(`/group/${group.slug}/plan-subscription${queryString.length > 0 ? `?${queryString}` : ""}`);
        }
      }
      if (params.get("join") === "true" && !selectPlan && window.location.pathname === "/") {
        joinGroup(freePlanId);
      }
    } else {
      setCheckingRedirect(false);
    }
  }

  const billingDetails = new URLSearchParams(window.location.search).get('section') === 'billing-details'

  useEffect(() => {
    if (
      group &&
      !group.menu['billing']['show'] &&
      window.location.pathname === '/about' &&
      billingDetails
    ) {
      toast("Page disabled by community admin", {
        type: 'info',
        autoClose: 3000,
        position: "top-center",
        hideProgressBar: true,
        theme: "light"
      });
      if (group.home_page_config.status) {
        window.location.assign("/");
      } else {
        window.location.assign(`/channel/${group.default_channel.slug}`);
      }
    }
  }, [window.location.pathname, billingDetails, group])

  useEffect(() => {
    if (window.location.pathname === "/" && (params.get("join") || params.get("utm_content"))) {
      setCheckingRedirect(true);
    } else {
      setCheckingRedirect(false);
    }
  }, [window.location.pathname])

  function joinGroup(freePlanId: any) {
    const _user: any = user;
    if (_user) {
      GroupService.getInstance()
        .membershipRequest(_user.id, group.id, '', "", freePlanId)
        .then((response: any) => {
          window.location.reload();
        }).catch((error: any) => console.error(error))
    } else {
      window.location.reload();
    }
  }

  function getCommunityFavicon() {
    if (group.favicon_image) {
      return group.favicon_image;
    }
  }

  const refreshGroupData = (onGroupDataRefresh?: any) => {
    if (group) {
      GroupService.getInstance()
        .getGroup(group.id)
        .then((groupData: any) => {
          setGroup(groupData);
          if (onGroupDataRefresh) {
            onGroupDataRefresh();
          }
        })
        .catch(() => { });
    }
  }

  const [, setCommunityBillingPlansPopup] = useAtom(communityBillingPlansPopupAtom) as any;

  function showUpgradepopupForFreePlans(title: string) {
    const plan = miscUtils.getGroupPlan(group);
    if (plan && plan.price === 0) {
      setCommunityBillingPlansPopup({
        open: true,
        title: `Upgrade plan to ${title}`,
      });
      return true;
    }
    return false;
  }

  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  const groupAppHomePage = Boolean(baseUrl === miscUtils.getBaseDomain())

  const CHECK_INTERVAL = 5000; // 5 seconds

  useEffect(() => {
    if (!isAuthed && window.location.pathname === '/signin') {
      const expirationTimeStr: any = localStorage.getItem(`user_token_expires`);

      const expirationTime: any = new Date(expirationTimeStr)// Convert back to date
      const timeLeft = expirationTime.getTime() - Date.now();
       const timeSinceExpiration = Math.abs(timeLeft); 

      if (timeLeft <= CHECK_INTERVAL ) {
        if (expirationTimeStr && (timeSinceExpiration <= (30 * 60 * 1000))) {
          toast("Your session has expired. Please log in.", {
            type: 'error',
            autoClose: 5000,
            position: "top-center",
            hideProgressBar: true,
            theme: "light"
          });
        }
      }

      setTimeout(() => {
        localStorage.removeItem(`user_token_expires`);
      }, 2000);
    }
  }, [isAuthed, window.location.pathname]);

  function checkCookieExpiry() {
    // Retrieve and parse expiration time from localStorage
    const expirationTimeStr = localStorage.getItem(`user_token_expires`);
    if (!expirationTimeStr) return;

    const expirationTime = new Date(expirationTimeStr); // Convert back to date
    const timeLeft = expirationTime.getTime() - Date.now();

    if (timeLeft <= CHECK_INTERVAL) { // 5 seconds warning threshold
      logoutUser();
    }
  }

  function logoutUser() {
    // Remove token and user info
    removeCookieValue(CommonConstants.USER_KEY);
    removeCookieValue(CommonConstants.USER_TOKEN);

    localStorage.removeItem(`user_logged_out`)

    // Redirect user to signin page
    window.location.replace("/signin");
  }

  useEffect(() => {
    if (isAuthed) {
      // Check for expiration periodically
      const interval = setInterval(checkCookieExpiry, CHECK_INTERVAL);

      // Listen for logout events from other tabs
      const handleStorageChange = (event: StorageEvent) => {
        if (event.key === "user_logged_out") {
          window.location.replace("/signin");
          localStorage.clear();
        }
      };

      window.addEventListener("storage", handleStorageChange);

      return () => {
        clearInterval(interval);
        window.removeEventListener("storage", handleStorageChange);
      };
    }
  }, [isAuthed]);

  function determineContainer() {

    if (userBlockedError.includes('User is blocked in community') && isAuthed) {
      return <div className="user-blocked-container">
        <NotFoundComponentAlt
          group={group}
          user
          message={<AccessRestricted
            user
            authed
            group={group}
            message="Error 404: Page not ound"
            subHeading="Contact the community administrator for more details."
            showActionMessage={false}
          />}
          showSubMessage={false}
        />
      </div>
    }

   if (groupDataError) {
      return <div className="user-blocked-container">
        <NotFoundComponent
          group={group}
          message={groupDataError.status === 404 ? 'Page not found!' : groupDataError.data && groupDataError.data.message}
          user={user}
          errorCode={groupDataError.status}
          showSubMessage={true}
          subMessage={"Sign up to create or join a community. "}

        />
      </div>
    }

    if (!isLoadingGroup && ((isCustomDomain && !subdomain) || (subdomain && !group))) {
      return <NotFound
        message={"Page not found!"}
        subMessage={!user ? "Sign up to create or join a community. " : undefined}
        user={user}
      />;
    }

    if (subdomain !== undefined) {
      if (subdomain === null) {
        if (window.location.pathname === "/" && !isAuthed) {
          switch (true) {
            case window.location.pathname === "/" &&
              subdomain === null &&
              !isAuthed:
              baseResponsiveClass =
                "res-user-access-container res-no-sub-nav res-login";
              return <UserAccesContainer subdomain={subdomain} group={group} />;
          }
        }
        // added because I cant figure what causing the slowness on user group  page
        else if (groupAppHomePage && isAuthed && window.location.pathname === "/") {
          switch (true) {
            case window.location.pathname === "/" && groupAppHomePage:
              baseResponsiveClass = "res-group-container groupapp-home-page";
              return <Home />;
          }

        }
        else {
          switch (true) {
            case window.location.pathname === "/" &&
              subdomain === null &&
              !isAuthed:
              baseResponsiveClass =
                "res-user-access-container res-no-sub-nav res-login";
              return <UserAccesContainer subdomain={subdomain} group={group} />;
            case window.location.pathname.includes("members") &&
              !window.location.pathname.includes("settings"):
              baseResponsiveClass = "res-group-container";
              return <GroupContainer subdomain={subdomain} />;
            case window.location.pathname.split('/').pop() === "notifications":
              baseResponsiveClass = "res-notification-container res-no-sub-nav";
              return (
                <NotificationsContainer
                  subdomain={subdomain}
                  group={group}
                  refreshNotificationsCountRef={refreshNotificationsCountRef}
                />
              );
            case window.location.pathname.includes("/stripe-connect"):
              baseResponsiveClass = "res-group-container res-no-sub-nav";
              return <GroupContainer subdomain={subdomain} />;
            case window.location.pathname.includes("/integration-authorized"):
              baseResponsiveClass = "res-group-container res-no-sub-nav";
              return <GroupContainer subdomain={subdomain} />;
            case window.location.pathname.includes("/shopify-custom-installation"):
              baseResponsiveClass = "res-group-container res-no-sub-nav";
              return <GroupContainer subdomain={subdomain} />;
            case window.location.pathname.includes("/kit-custom-installation"):
              baseResponsiveClass = "res-group-container res-no-sub-nav";
              return <AdminCommunities isAuthed={isAuthed}/>;
            case window.location.pathname.includes("/plan-subscription"):
              baseResponsiveClass = "res-group-container res-no-sub-nav";
              return <GroupContainer subdomain={subdomain} group={group} />;
            case window.location.pathname.includes("courses") &&
              !window.location.pathname.includes("settings"):
              baseResponsiveClass = "res-group-container res-courses";
              return <GroupContainer subdomain={subdomain} toggleLectureMenuRef={toggleLectureMenuRef} />;
            case window.location.pathname.includes("library") &&
              !window.location.pathname.includes("settings"):
              baseResponsiveClass = "res-group-container res-library";
              return <GroupContainer subdomain={subdomain} />;
            case window.location.pathname.includes("events") &&
              !window.location.pathname.includes("settings"):
              baseResponsiveClass = "res-group-container";
              return <GroupContainer subdomain={subdomain} />;
            case window.location.pathname.split("/")[1] === "pages-preview":
              baseResponsiveClass = "res-group-container res-no-sub-nav";
              return <GroupContainer subdomain={subdomain} />;
            case window.location.pathname.split("/")[1] === "home":
              baseResponsiveClass = "res-group-container res-no-sub-nav";
              return <GroupContainer subdomain={subdomain} />;
            case window.location.pathname.split("/")[1] === "about-community":
              baseResponsiveClass = "res-group-container res-no-sub-nav";
              return <GroupContainer subdomain={subdomain} />;
            case window.location.pathname.split("/")[1] === "pages":
              baseResponsiveClass = "res-group-container res-no-sub-nav";
              return <GroupContainer subdomain={subdomain} />;
            case window.location.pathname.split("/")[2] === "branding" &&
              window.location.pathname.split("/")[1] === "settings":
              baseResponsiveClass =
                "res-group-container res-no-sub-nav res-admin-page";
              return <GroupContainer subdomain={subdomain} />;
            case window.location.pathname.includes("/plan-subscription-preview"):
              baseResponsiveClass = "res-group-container res-no-sub-nav";
              return <GroupContainer subdomain={subdomain} />;
            case window.location.pathname.includes("/manage-subscription"):
              baseResponsiveClass = "res-group-container res-no-sub-nav";
              return <GroupContainer subdomain={subdomain} />;
            case window.location.pathname.includes("/user-subscriptions"):
              baseResponsiveClass = "res-group-container res-no-sub-nav";
              return <GroupContainer subdomain={subdomain} />;
            case window.location.pathname.includes("settings"):
              baseResponsiveClass =
                "res-group-container res-no-sub-nav res-admin-page";
              return <GroupContainer subdomain={subdomain} setCommunityFavicon={setCommunityFavicon} />;
            case window.location.pathname.includes("/group"):
              baseResponsiveClass = "res-group-container";
              return (
                <GroupContainer
                  subdomain={subdomain}
                />
              );
            case window.location.pathname.includes("email_unsubscription"):
              baseResponsiveClass = "res-group-container res-no-sub-nav";
              return <GroupContainer subdomain={subdomain} />;
            case window.location.pathname.includes("group_billing_cancellation"):
              baseResponsiveClass = "res-group-container res-no-sub-nav";
              return <GroupContainer subdomain={subdomain} />;
            case window.location.pathname === "/":
              baseResponsiveClass = "res-group-container";
              return <GroupContainer subdomain={subdomain} />;
            case window.location.pathname === "/settings":
              baseResponsiveClass = "res-group-container res-no-sub-nav";
              return <GroupContainer subdomain={subdomain} />;
            case window.location.pathname.includes("posts"):
              baseResponsiveClass = "res-group-container";
              return <GroupContainer subdomain={subdomain} />;
            case window.location.pathname.includes("/feed"):
              baseResponsiveClass = "res-group-container";
              return <GroupContainer subdomain={subdomain} />;
            case window.location.pathname.includes("channel"):
              baseResponsiveClass = "res-group-container";
              return <GroupContainer subdomain={subdomain} />;
            case window.location.pathname.includes("/creategroup"):
              baseResponsiveClass = "res-create-group-container res-no-sub-nav";
              return <CreateGroupContainer />;
            case window.location.pathname.includes("about"):
              baseResponsiveClass = "res-user-settings-container res-no-sub-nav";
              return (
                <UserSettingsContainer subdomain={subdomain} group={group} />
              );
            case window.location.pathname.includes("search"):
              baseResponsiveClass = "res-search-container res-no-sub-nav";
              return <SearchContainer />;
            case window.location.pathname.includes("login"):
              baseResponsiveClass =
                "res-user-access-container res-no-sub-nav res-login";
              return <UserAccesContainer group={group} />;
            case window.location.pathname.includes("signup"):
              baseResponsiveClass =
                "res-user-access-container res-no-sub-nav res-signup self-signup";
              return <UserAccesContainer group={group} />;
            case window.location.pathname.includes("verify-account"):
              baseResponsiveClass =
                "res-user-access-container res-no-sub-nav res-signup self-signup";
              return <UserAccesContainer group={group} />;
            case window.location.pathname.includes("create-community"):
              baseResponsiveClass =
                "res-user-access-container res-no-sub-nav res-signup self-signup";
              return <UserAccesContainer group={group} />;
            case window.location.pathname.includes("forgot-password"):
              baseResponsiveClass =
                "res-user-access-container res-no-sub-nav res-forgot-password";
              return <UserAccesContainer group={group} />;
            case window.location.pathname.includes("reset-password"):
              baseResponsiveClass =
                "res-user-access-container res-no-sub-nav res-reset-password";
              return <UserAccesContainer group={group} />;
            case window.location.pathname.includes("email_unsubscription") &&
              !isAuthed:
              baseResponsiveClass = "res-user-access-container res-no-sub-nav";
              return <UserAccesContainer group={group} />;
            case window.location.pathname.includes("onboarding"):
              baseResponsiveClass =
                "res-user-access-container res-no-sub-nav res-reset-password";
              return <UserAccesContainer group={group} />;
            case window.location.pathname.includes("join_group"):
              baseResponsiveClass =
                "res-user-access-container res-no-sub-nav res-reset-password";
              return <UserAccesContainer group={group} />;
            case window.location.pathname.includes("community-email-verification-success"):
              baseResponsiveClass =
                "res-user-access-container res-no-sub-nav res-signup self-signup";
              return <EmailWhitelabelingSuccess />;
            case window.location.pathname.includes("community-email-verification-failure"):
              baseResponsiveClass =
                "res-user-access-container res-no-sub-nav res-signup self-signup";
              return <EmailWhitelabelingSuccess />;
          }
        }
      } else {
        switch (true) {
          case window.location.pathname.includes("verify-email"):
            baseResponsiveClass =
              "res-user-access-container res-no-sub-nav res-signup self-signup";
            return <VerifyAccountComponent
              // @ts-ignore
              groupId={group && group.id}
              CommuinityTheme={group && group.custom_branding}
            />;
          case window.location.pathname.includes("members") &&
            !window.location.pathname.includes("settings"):
            baseResponsiveClass = "res-group-container";
            return <GroupContainer subdomain={subdomain} group={group} />;
          case window.location.pathname.includes("members") &&
            window.location.pathname.includes("settings"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("channels") &&
            window.location.pathname.includes("settings"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          // case window.location.pathname.includes("custom-domain") &&
          //   window.location.pathname.includes("settings"):
          //   baseResponsiveClass =
          //     "res-group-container res-no-sub-nav res-admin-page";
          //   return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("courses") &&
            window.location.pathname.includes("settings"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("library") &&
            window.location.pathname.includes("settings"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("events") &&
            window.location.pathname.includes("settings"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("subscription") &&
            window.location.pathname.includes("settings"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("requests") &&
            window.location.pathname.includes("settings"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("teams") &&
            window.location.pathname.includes("settings"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("onboarding") &&
            window.location.pathname.includes("settings"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("verify-account"):
            window.location.replace(`${miscUtils.getBaseDomain()}/verify-account?s=false`);
          case window.location.pathname.includes("schedule") &&
            window.location.pathname.includes("settings"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("workflows") &&
            window.location.pathname.includes("settings"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("homepage") &&
            window.location.pathname.includes("settings"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("admin-dashboard") &&
            window.location.pathname.includes("settings"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("landing-pages") &&
            window.location.pathname.includes("settings"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.split("/")[2] === "certificates" &&
            window.location.pathname.split("/")[1] === "settings":
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("moderation") &&
            window.location.pathname.includes("settings"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("segments") &&
            window.location.pathname.includes("settings"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("analytics") &&
            window.location.pathname.includes("settings"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("details") &&
            window.location.pathname.includes("settings"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} setCommunityFavicon={setCommunityFavicon} />;
          case window.location.pathname.includes("billing") &&
            window.location.pathname.includes("settings"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.split('/').pop() === "invite" &&
            window.location.pathname.includes("settings"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.split('/').pop() === "invite-preview" &&
            window.location.pathname.includes("settings"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.split('/').pop() === "notifications":
            baseResponsiveClass = "res-notification-container res-no-sub-nav";
            return (
              <NotificationsContainer
                subdomain={subdomain}
                group={group}
                refreshNotificationsCountRef={refreshNotificationsCountRef}
              />
            );
          case window.location.pathname === '/signup-disabled':
            baseResponsiveClass = "res-group-container";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname === '/plan-disabled':
            baseResponsiveClass = "res-group-container";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("courses") &&
            !window.location.pathname.includes("settings"):
            baseResponsiveClass = "res-group-container res-courses";
            return <GroupContainer subdomain={subdomain} toggleLectureMenuRef={toggleLectureMenuRef} />;
          case window.location.pathname.includes("alts") &&
            !window.location.pathname.includes("settings"):
            baseResponsiveClass = "res-group-container res-courses";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("library") &&
            !window.location.pathname.includes("settings"):
            baseResponsiveClass = "res-group-container res-library";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("events") &&
            !window.location.pathname.includes("settings"):
            baseResponsiveClass = "res-group-container";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("/stripe-connect"):
            baseResponsiveClass = "res-group-container res-no-sub-nav";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("/integration-authorized"):
            baseResponsiveClass = "res-group-container res-no-sub-nav";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("/shopify-custom-installation"):
            baseResponsiveClass = "res-group-container res-no-sub-nav";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("/kit-custom-installation"):
            baseResponsiveClass = "res-group-container res-no-sub-nav";
            return <AdminCommunities isAuthed={isAuthed}/>;
          case window.location.pathname === "/invite" &&
            !window.location.pathname.includes("settings"):
            baseResponsiveClass = "res-user-access-container res-no-sub-nav";
            return <UserAccesContainer subdomain={subdomain} group={group} isAuthed={isAuthed} />;
          case window.location.pathname === "/invite-preview" &&
            !window.location.pathname.includes("settings"):
            baseResponsiveClass = "res-user-access-container res-no-sub-nav";
            return <UserAccesContainer subdomain={subdomain} group={group} isAuthed={isAuthed} />;
          case window.location.pathname === "/about-preview" &&
            !window.location.pathname.includes("settings"):
            baseResponsiveClass = "res-group-container res-no-sub-nav";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("/plan-subscription"):
            baseResponsiveClass = "res-group-container res-no-sub-nav";
            return <GroupContainer subdomain={subdomain} group={group} />;
          case window.location.pathname.includes("/sso/oauth/callback") &&
            !window.location.pathname.includes("settings"):
            baseResponsiveClass = "res-group-container";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.split("/")[1] === "pages-preview":
            baseResponsiveClass = "res-group-container res-no-sub-nav";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.split("/")[1] === "home":
            baseResponsiveClass = "res-group-container res-no-sub-nav";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.split("/")[1] === "about-community":
            baseResponsiveClass = "res-group-container res-no-sub-nav";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.split("/")[1] === "pages":
            baseResponsiveClass = "res-group-container res-no-sub-nav";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.split("/")[2] === "branding" &&
            window.location.pathname.split("/")[1] === "settings":
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("/plan-subscription-preview"):
            baseResponsiveClass = "res-group-container res-no-sub-nav";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("/manage-subscription"):
            baseResponsiveClass = "res-group-container res-no-sub-nav";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("/user-subscriptions"):
            baseResponsiveClass = "res-group-container res-no-sub-nav";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("/group"):
            baseResponsiveClass = "res-group-container";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("/messages"):
            baseResponsiveClass = "res-group-container";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("/filter"):
            baseResponsiveClass = "res-group-container";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("email_unsubscription"):
            baseResponsiveClass = "res-group-container res-no-sub-nav";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("group_billing_cancellation"):
            baseResponsiveClass = "res-group-container res-no-sub-nav";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname === "/":
            baseResponsiveClass = "res-group-container";
            return (
              <GroupContainer
                subdomain={subdomain}
              />
            );
          case window.location.pathname.includes("/signin") &&
            !window.location.pathname.includes("settings"):
            baseResponsiveClass = "res-group-container";
            return <UserAccesContainer subdomain={subdomain} group={group} isAuthed={props.isAuthed} />;
          case window.location.pathname.split("/")[1] === "new-password":
            baseResponsiveClass = "res-group-container";
            return <UserAccesContainer subdomain={subdomain} group={group} isAuthed={props.isAuthed} />;
          case window.location.pathname.split("/")[1] === "new-name":
            baseResponsiveClass = "res-group-container";
            return <UserAccesContainer subdomain={subdomain} group={group} isAuthed={props.isAuthed} />;
          case window.location.pathname === "/settings":
            baseResponsiveClass = "res-group-container res-no-sub-nav";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("posts"):
            baseResponsiveClass = "res-group-container";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("/feed"):
            baseResponsiveClass = "res-group-container";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("channel"):
            baseResponsiveClass = "res-group-container";
            return (
              <GroupContainer
                subdomain={subdomain}
              />
            );
          case window.location.pathname.includes("/creategroup"):
            baseResponsiveClass = "res-create-group-container res-no-sub-nav";
            return <CreateGroupContainer />;
          case window.location.pathname.includes("about"):
            baseResponsiveClass = "res-user-settings-container res-no-sub-nav";
            return (
              <UserSettingsContainer subdomain={subdomain} group={group} />
            );
          case window.location.pathname.includes("search"):
            baseResponsiveClass = "res-search-container res-no-sub-nav";
            return <SearchContainer />;
          case window.location.pathname.includes("login"):
            baseResponsiveClass =
              "res-user-access-container res-no-sub-nav res-login";
            return <UserAccesContainer subdomain={subdomain} group={group} />;
          case window.location.pathname.includes("signup"):
            baseResponsiveClass =
              "res-user-access-container res-no-sub-nav res-signup";
            return <UserAccesContainer group={group} />;
          case window.location.pathname.includes("forgot-password"):
            baseResponsiveClass =
              "res-user-access-container res-no-sub-nav res-forgot-password";
            return <UserAccesContainer group={group} />;
          case window.location.pathname.includes("reset-password"):
            baseResponsiveClass =
              "res-user-access-container res-no-sub-nav res-reset-password";
            return <UserAccesContainer group={group} />;
          case window.location.pathname.includes("email_unsubscription") &&
            !isAuthed:
            baseResponsiveClass = "res-user-access-container res-no-sub-nav";
            return <UserAccesContainer group={group} />;
          case window.location.pathname.includes("integrations"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("events"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("onboarding")
            && window.location.pathname.includes("settings"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("schedule"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("workflows"):
            baseResponsiveClass =
              "res-group-container res-no-sub-nav res-admin-page";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname === "/onboarding":
            baseResponsiveClass =
              "res-group-container res-no-sub-nav";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname === "/upgrade":
            baseResponsiveClass =
              "res-group-container res-no-sub-nav";
            return <GroupContainer subdomain={subdomain} />;
          case window.location.pathname.includes("join_group"):
            baseResponsiveClass =
              "res-user-access-container res-no-sub-nav res-reset-password";
            return <UserAccesContainer group={group} />;
          default:
            return <NotFound message={"Page not found.!"} />;
        }
      }
    }
  }

  function showTopBar() {
    return (
      !(
        window.location.pathname === "/" &&
        !isAuthed &&
        (
          window.location.hostname === 'my.group.app' ||
          window.location.hostname === 'group.app' ||
          window.location.hostname === 'group.localhost' ||
          window.location.hostname === 'staging.group.app'
        )
      ) &&
      !(
        window.location.pathname === "/" &&
        window.location.hostname !== 'my.group.app' &&
        window.location.hostname !== 'group.app' &&
        window.location.hostname !== 'group.localhost' &&
        window.location.hostname !== 'staging.group.app'
      ) &&
      window.location.pathname !== "/login" &&
      window.location.pathname !== "/signup" &&
      window.location.pathname !== "/verify-account" &&
      window.location.pathname !== "/create-community" &&
      window.location.pathname !== "/signin" &&
      window.location.pathname !== "/forgot-password" &&
      window.location.pathname !== "/reset-password" &&
      window.location.pathname.split("/")[1] !== "pages" &&
      window.location.pathname.split("/")[1] !== "pages-preview" &&
      !(
        window.location.pathname.split("/")[2] === "landing-pages" &&
        window.location.pathname.split("/").pop() === "edit"
      ) &&
      !(
        window.location.pathname.split("/")[2] === "certificates" &&
        window.location.pathname.split("/").pop() === "edit"
      ) &&
      window.location.pathname !== "/upgrade"
      //  && window.location.pathname !== "/integration-authorized"
    );
  }

  function getTrialDate() {
    if (group) {
      return miscUtils.convertDateStringToUsertimezoneFormat(group.active_subscription.trial_ends_at);
    }
  }

  function getTrialStatus() {
    if (
      group &&
      group.active_subscription &&
      group.active_subscription.on_trial &&
      window.location.pathname !== "/onboarding" &&
      window.location.pathname !== "/upgrade"
    ) {
      setOnTrial(true);
    } else {
      setOnTrial(false);
    }
  }

  function isADayLeftOnTrial() {
    if (miscUtils.getDateDiffInHours(group && group.active_subscription.trial_ends_at) >= 22 && miscUtils.getDateDiffInHours(group && group.active_subscription.trial_ends_at) <= 35) {
      return true;
    }

    return false;
  }

  /**
   * Render app DOM component
   *
   * @returns
   *
   * @memberof Main
   */
  const container = determineContainer();

  function resendCode() {
    AuthorizeService.getInstance()
      .resendVerificationCode(group && group.id)
      .finally(() => {
        toast("Verification code has been sent.", {
          type: 'success',
          autoClose: 3000,
          position: "top-center",
          hideProgressBar: true,
          theme: "light"
        });
        props.history.push('/verify-email?cm=true&s=false')
      });
  }

  const previewPage = (window.location.pathname === '/plan-subscription-preview') || (window.location.pathname === '/about-preview')
  const isGroupDataRequired =
    window.location.hostname !== 'my.group.app' &&
    window.location.hostname !== 'group.localhost' &&
    window.location.hostname !== 'staging.group.app';

  const isHomePage = window.location.pathname.split("/")[1] !== "settings";
  
  // Only check for CommunityProfileCard if the user is on the home page
  const communityProfileCardExists = isHomePage && !!document.getElementById("GroupAppHeader");
  // const switcherElement: any = document.getElementById('communities-sidebar');

  return (
    <>
    { 
   (((!group || (group === null)) && userBlockedError.length === 0) && isGroupDataRequired)
   ?
   <div className='main-app-loader'>
     <AppLoadingSpinner loaderSize={17} />
   </div>
:
    <div 
    id="master" className={`${baseResponsiveClass} ${onboardingChecklistActive}`}>
      {
        pixelId &&
        <Facebook pixelId={pixelId} />
      }

      <AppContext.Provider
        value={{
          toggleLectureMenuRef,
          refreshGroupData,
          isSidebarEmptyRef,
          resetGroupDataRef,
          group,
          setGroup,
          showDefaultLandingPage,
          setShowDefaultLandingPage,
          groupChannels, 
          setGroupChannels,
          groupMembershipData,
          setGroupMembershipData,
          refreshGroupPostsWithoutLoadRef,
          loggedinUser, setLoggedinUser,
          isGroupEligibleForTrial,
          setIsGroupEligibleForTrial,
        }}
      >
        <DirectChatsContext.Provider
          value={{
            directChats,
            isLoadingMessages,
            setIsLoadingMessages,
            chatroom,
            setChatroom,
            isCreateDirectchat,
            setIsCreateDirectchat,
            group,
            memberCommunityUnreadCount,
            getCommunityUnread,
            chatIsclicked, setChatIsclicked,
            chatHistory, setChatHistory,
            isMemberAddGroupChat, setIsMemberAddGroupChat,
            membersRef,
            getDirectChats,
            setMemberCommunityUnreadCount,
            loadMoreChats,
            showUpgradepopupForFreePlans
          }}
        >
          <>
            {
              showTopBar() && (!isGroupDataRequired || group) &&
              <TopBarComponent
                user={user}
                getUserGroups={getUserGroups}
                authed={isAuthed}
                logout={logout}
                subdomain={subdomain}
                toggleLectureMenuRef={toggleLectureMenuRef}
                group={group}
                refreshNotificationsCountRef={refreshNotificationsCountRef}
              />
            }
            {
              user && group && previewPage && miscUtils.isAdmin(group.user_membership) ? <PreviewBanner /> : <></>
            }

            {
              openMessagePopUp &&
              <MessagingContainer
                isAuthed={isAuthed}
                subdomain={subdomain}
                group={group && group}
                theme={global.theme}
              />
            }

            {
              // admins' checklist linker
              (
                isAuthed &&
                group &&
                group.user_membership &&
                miscUtils.isAdmin(group.user_membership) &&
                !(//user is on upgrade screen
                  window.location.pathname.split("/").length === 2 &&
                  window.location.pathname.split("/").pop() === "upgrade"
                ) &&
                !(//user is on onboarding screen
                  window.location.pathname.split("/").length === 2 &&
                  window.location.pathname.split("/").pop() === "onboarding"
                ) &&
                !( //user is already on billing screen
                  window.location.pathname.split("/").length === 4 &&
                  window.location.pathname.split("/")[2] === "billing" &&
                  window.location.pathname.split("/").pop() === "plans"
                ) &&
                !(//user is on plan confirmation page
                  window.location.pathname.split("/").length === 6 &&
                  window.location.pathname.split("/")[2] === "billing" &&
                  window.location.pathname.split("/").pop() === "confirmation"
                ) &&
                !(//user is in landing page builder
                  window.location.pathname.split("/")[2] === "landing-pages" &&
                  window.location.pathname.split("/").pop() === "edit"
                ) &&
                !(//user is in workflows builder
                  window.location.pathname.split("/")[2] === "workflows" &&
                  window.location.pathname.split("/").pop() === "edit"
                ) &&
                !(//user is in certificates builder
                  window.location.pathname.split("/")[2] === "certificates" &&
                  window.location.pathname.split("/").pop() === "edit"
                ) &&
                (!isHomePage || communityProfileCardExists) &&// Only check `communityProfileCardExists` if `isHomePage` is true
                <AdminOnboardingChecklist groupData={group} />
              )
            }

            {
              openMessagePopUp &&
              <MessagingContainer
                isAuthed={isAuthed}
                subdomain={subdomain}
                group={group && group}
                theme={global.theme}
              />
            }

            {
              openNewCommunityPopup && group &&
              <NewCommunityPopup />
            }

            {global.showTopLoading && (
              <MainLoading
                isLoading={global.showTopLoading}
                pastDelay={false}
                timedOut={false}
                retry={() => {
                }}
                error={null}
              />
            )}
            {!checkingRedirect && (
              <main id={"site-content"} className={`${isInvitePreview ? "is--invite-preview" : ""} ${isInvited ? "is--invited-wrap" : ""} ${showTopBar() ? "show-topbar" : ""}`}>
                {container}
              </main>
            )}
            {showFavicon ? (
              <Favicon url={communityFavicon} />
            ) : (
              <Favicon url={defaultFaviconUrl} />
            )}
          </>

        </DirectChatsContext.Provider>
      </AppContext.Provider>
    </div>
    }
    </>
  );
};

const mapDispatchToProps = (dispatch: any, ownProps: IMainComponentProps) => {
  return {
    login: (user: any) => {
      dispatch(authorizeActions.login(user));
    },
    logout: () => {
      dispatch(authorizeActions.dbLogout());
    },
    getUserGroups: (userId: any) => {
      if (userId) {
        dispatch(groupActions.dbGetUserGroups(userId));
      }
    },
    goTo: (url: string) => dispatch(push(url)),
    hideTopLoading: () => dispatch(globalActions.hideTopLoading()),
    showMasterLoading: () => dispatch(globalActions.showMasterLoading()),
    hideMasterLoading: () => dispatch(globalActions.hideMasterLoading()),
    clearMessage: () => dispatch(globalActions.clearMessage())
  };
};

const mapStateToProps = (state: Map<string, any>) => {
  const authorize = Map(state.get("authorize", {})).toJS() as any;
  const global = Map(state.get("global", {})).toJS() as any;
  const selectedGroup: string = state.getIn(["group", "selectedGroup"]) as string;
  const globalUser: any = state.getIn(["authorize", "user"]);
  const { sendFeedbackStatus, progress } = global;

  return {
    globalUser,
    global,
    sendFeedbackStatus,
    progress,
    selectedGroup,
    guest: authorize.guest,
    uid: authorize.uid,
    isAuthed: authorize.authed
  };
};

const EnhancedMainComponent = Sentry.withProfiler(MainComponent as any);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Sentry.withProfiler(EnhancedMainComponent as any)) as any
);
